var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/technical_metrics.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var TheView = GenericView.extend({
    el: '#technical_metrics',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	initialize: function (options) {
	    this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template(this.data));
        this.createLineChart('scr-bsChart', 'BESS size (kWh)', 'SCR (%)', this.data.parametricSCR, this.data.batSizes, "#ed7d31");
        this.createLineChart('ssr-bsChart', 'BESS size (kWh)', 'SSR (%)', this.data.parametricSSR, this.data.batSizes, "#1f4e79");
    },
    events: {
        "click #exportTechnical" : "exportData"
    },
    createLineChart: function(chart, x, y, data, labels, color) {
        var ctx = document.getElementById(chart).getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: $.map(labels, function(element) {
                            return element.toFixed(1);
                }),
                datasets: [
                    {
                        borderColor: color,
                        fill: false,
                        data: data
                    }
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                legend: false,
                layout: {
                    padding: {
                        left: 10,
                        right:10,
                        top: 20,
                        bottom: 20
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: x
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: y
                        }
                    }]
                }
            }
        });

        myChart.canvas.parentNode.style.height = '350px';
        myChart.canvas.parentNode.style.width = '45%';
    },
     exportData: function() {
          var self = this;

          $.ajax({
              url: "/api/export/technicalMetrics",
              type: "POST",
              contentType: "application/json",
              data: JSON.stringify({
                        scr: self.data.scr,
                        ssr: self.data.ssr,
                        pvSizes: $.map(self.data.pvsizes, function(element) {
                                      return element.toFixed(1);
                        }),
                        batSizes: $.map(self.data.batSizes, function(element) {
                                      return element.toFixed(1);
                        }),
                        parametricSCR: $.each(self.data.scr, function(index, subArray) {
                                          var tMap = $.map(subArray, function(elem) {
                                                if( isNaN(elem) ) {
                                                     return elem;
                                                }
                                                else {
                                                      return Handlebars.helpers.decimalDigits(elem,2);
                                                }
                                         });
                                        self.data.scr[index] = tMap;
                        }),
                        parametricSSR: $.each(self.data.ssr, function(index, subArray) {
                                             var tMap = $.map(subArray, function(elem) {
                                                   if( isNaN(elem) ) {
                                                        return elem;
                                                   }
                                                   else {
                                                         return Handlebars.helpers.decimalDigits(elem,2);
                                                   }
                                            });
                                           self.data.ssr[index] = tMap;
                       })
               }),
              dataType : 'binary',
              xhrFields : {
                 'responseType' : 'blob'
              }
          }).done(function(response) {
             var url = URL.createObjectURL(response);
             var $a = $('<a />', {
               'href': url,
               'download': 'TechnicalMetrics.csv',
               'text': "click"
             }).hide().appendTo("body")[0].click()
          }).fail(function(resp, xhr, errorMessage) {
              console.error("resp: ", resp);
              console.error("xhr: ", xhr);
              console.error("status: ", errorMessage);
          });

     }
});

module.exports= TheView;